import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export enum PersonelTypes {
  SABIT = 'SABIT',
  DIGER = 'DIGER'
}

export class IPersonel {
  id: string;
  creatorId: number;
  createdAt: string;
  name: string;
  status: number;
  regionId: number;
  gorevId: string;
  supplierId: string;
  userId: number;
  type: PersonelTypes;
  education: number;
  tc: string;
  shiftId?: string;
  shift?: {
    id: string;
    name: string;
    startTime: string;
    endTime: string;
  };
}

export class IPersonelResponse {
  @Type(() => IPersonel)
  result: IPersonel;
}

export class IPersonelListResponse extends IPagination {
  @Type(() => IPersonel)
  results: IPersonel[];
}

export class IPersonelQueryDto extends IQueryPaginationDto {
  id?: string;
  tc?: string;
  name?: string;
}

export class IPersonelPostDto {
  creatorId: number;
  name: string;
  status: number;
  regionId: number;
  gorevId: string;
  supplierId: string;
  userId?: number;
  type: PersonelTypes;
  education: number;
  tc: string;
  shiftId?: string;
}

export class IPersonelPatchDto {
  name?: string;
  status?: number;
  regionId?: number;
  gorevId?: string;
  supplierId?: string;
  userId?: number;
  type?: PersonelTypes;
  education?: number;
  tc?: string;
  shiftId?: string;
}
